import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { SelectSellingTypeStepOptions } from './components/SelectSellingTypeStepOptions';
import { useAppStore } from 'stores/state';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const SelectSellingTypeStep: FC = () => {
  const { t } = useTranslation();

  const sellingTypes = useAppStore((state) => state.sellingTypes);

  return (
    <StepLayout
      title={t('select-selling-type-step.title')}
      description={t('select-selling-type-step.description')}
      nextButtonProps={{ label: t('select-selling-type-step.actions.next-button'), disabled: !sellingTypes.length }}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectSellingType],
          action: BI_ACTION_NAME.NEXT,
          value: sellingTypes.join(','),
        });
      }}
    >
      <SelectSellingTypeStepOptions />
    </StepLayout>
  );
};
